module.exports = {
    defaultLanguage: 'es',
    profileColor: {saturation: 70, brightness: 100},
    scssVariables: './src/styles/beldent',
    defaultPassword: 'default'
}